import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const SCUIGeneralDrawerHeader = (props: any) => {
    return (
        <Box
            className={props.rootClassName}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                paddingTop: 2,
                paddingBottom: 2,
                paddingLeft: 2,
                paddingRight: 2,
                borderBottom: '1px solid #e0e0e0',
                boxSizing: 'border-box',
            }}
        >
            <h3
                className={['headtxt', props.titleClassName].filter(Boolean).join(' ')}
                style={{
                    margin: 0,
                    fontSize: '18px',
                    fontWeight: 1000,
                    flex: 1,
                    minWidth: 0,
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                }}
            >
                {props.header}
            </h3>
            <CloseIcon
                className={['svg_icons', props.closeIconClassName].filter(Boolean).join(' ')}
                onClick={props.onClose}
                style={{ cursor: 'pointer', flexShrink: 0, marginLeft: '8px' }}
            />
        </Box>
    );
};
